export * from './text.module';
export * from './text.component';

export * from './variant-b';
